import { render, staticRenderFns } from "./SupplierCreateDialog.vue?vue&type=template&id=18f3ebd7"
import script from "./SupplierCreateDialog.vue?vue&type=script&lang=js"
export * from "./SupplierCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports